// extracted by mini-css-extract-plugin
export default {"errorText":"style_errorText__srBFd","rowError":"style_rowError__5Y8Od"};